import { combineEpics } from 'redux-observable';
import { createSubscriptionEpic } from './create-subscription';
import { redirectAfterSubscribeEpic } from './redirect-after-subscribe';
import { getSubscriptionEpic } from './get-subscription';
import { getSubscriptionAfterActivateEpic } from './get-subscription-after-activate';
import { clearSubscriptionsEpic } from './clear-subscriptions';
import { getInvoicesEpic } from './get-invoices';
import { getInvoicesAfterActivateEpic } from './get-invoices-after-activate';
import { cancelSubscriptionEpic } from './cancel-subscription';
import { validateSubscriptionEpic } from './validate-subscription';
import { getSubscriptionAfterCreatedEpic } from './get-subscription-after-created';
import { getLabelSubscriptionEpic } from './get-label-subscription';
import { showSuccessMenuAfterCreatedEpic } from './show-success-menu-after-created';
import { hideSuccessMenuAfterCreatedEpic } from './hide-success-menu-after-created';

const subscriptionEpic = combineEpics(
  createSubscriptionEpic,
  getSubscriptionEpic,
  redirectAfterSubscribeEpic,
  getSubscriptionAfterActivateEpic,
  clearSubscriptionsEpic,
  getInvoicesEpic,
  getInvoicesAfterActivateEpic,
  cancelSubscriptionEpic,
  validateSubscriptionEpic,
  getSubscriptionAfterCreatedEpic,
  getLabelSubscriptionEpic,
  showSuccessMenuAfterCreatedEpic,
  hideSuccessMenuAfterCreatedEpic
);

export default subscriptionEpic;
